import { useCallback, useRef } from 'react';
import { useBlocker } from '@tanstack/react-router';

export function useTemplateEditNavigationGuard(hasUnsavedWork: boolean) {
  const allowNextNavigationRef = useRef(false);
  const blocker = useBlocker({
    disabled: !hasUnsavedWork,
    enableBeforeUnload: hasUnsavedWork,
    withResolver: true,
    shouldBlockFn: ({ current, next }) => {
      if (allowNextNavigationRef.current) {
        allowNextNavigationRef.current = false;
        return false;
      }

      const nextMode = (next.search as { mode?: unknown }).mode;
      return current.pathname !== next.pathname || nextMode !== 'edit';
    },
  });

  const allowNextNavigation = useCallback(() => {
    allowNextNavigationRef.current = true;
  }, []);

  return { blocker, allowNextNavigation };
}
